// Ürün kartlarındaki küçük renk kartları: üzerine gelince ana fotoğraf o renge döner, ayrılınca eski haline gelir.
// Tıklayınca (telefonda dokununca) o renk seçili olarak ürün sayfası açılır.
(function () {
  function mainImg(row) {
    var card = row.closest('.card-wrapper');
    return card && card.querySelector('.card__media .media > img:first-child');
  }

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('.kavi-cc__item');
    if (!item) return;
    var row = item.closest('[data-kavi-cc]');
    var img = mainImg(row);
    if (!img) return;
    if (!img.dataset.kcOrigSrc) {
      img.dataset.kcOrigSrc = img.getAttribute('src') || '';
      img.dataset.kcOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', item.dataset.kcSrcset);
    img.setAttribute('src', item.dataset.kcSrc);
    row.closest('.card-wrapper').classList.add('kavi-cc-swapping');
    row.querySelectorAll('.kavi-cc__item').forEach(function (i) { i.classList.toggle('is-active', i === item); });
  });

  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest && e.target.closest('[data-kavi-cc]');
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    var img = mainImg(row);
    if (img && img.dataset.kcOrigSrc) {
      img.setAttribute('srcset', img.dataset.kcOrigSrcset);
      img.setAttribute('src', img.dataset.kcOrigSrc);
    }
    row.closest('.card-wrapper').classList.remove('kavi-cc-swapping');
    row.querySelectorAll('.kavi-cc__item').forEach(function (i) { i.classList.remove('is-active'); });
  });
})();
